/***************************************************************
 * Extended Klaro Consent Tool
 *
 * extended:
 * 		- Trigger / Notice, click Funcs
 * 		- iFrame Fallback with klaro-activation
 * 		- Logging Callback Function -> cmlogger.php / .cfm
 *
 * By feedback werbeagentur GmbH
 * v 1.1.0 : fullScreen, fixes, coldfusion logger
 * v 1.2.0 : removed jQuery functions, modular split: klaro.extended.js, extra classes, iframe-settings
 * v 1.2.1 : fixed #klaro links
 * v.1.3.0** : iFrame CSS Rules (removed inline CSS), klaroApp-default push
 * 2020-07
 ***************************************************************/

// BASE CONFIGURATION / OVERWRITE IN CONSENT.CONFIG.JS
// AND EXTENSION SCRIPTS
var klaroBaseConfig = {
	elementID: 'klaro',
	storageMethod: 'localStorage',
	fullScreen: false, // extended // fullscreen cookie notice overlay
	extraClasses: [], // extended // array of strings
	cookieName: 'consent',
	cookieExpiresAfterDays: 365,
	privacyPolicy: '/datenschutz',
	noticetype: 'trigger', // extended // 'trigger' or 'notice'
	cmloggerurl: '/consent/cmlogger.php', //url of cmlogger file // extended
	default: false,
	mustConsent: false,
	acceptAll: true,
	hideDeclineAll: false,
	lang : 'de', // extended // internal use
	iframe: { // extended // iframe-settings
		enable: true, //enable/disable extended blocker + fallbacks of iframes
		texts: {
			de: {
				title: 'Dies ist ein externer Inhalt von ',
				desc: 'Wenn Sie die Inhalte sehen möchten geben Sie bitte Ihre Zustimmung und klicken Sie auf den Button.',
				btn: 'Externen Inhalt anzeigen',
				infobtn: 'Info'
			},
			en: {
				title: 'This is an external content provided by ',
				desc: 'If you would like to see the content please give your consent and click on the button.',
				btn: 'Show external content',
				infobtn: 'Info'
			},
		},
		styles: { //css values
			font: 'Roboto, Open Sans, Helvetica, Arial, sans-serif',
			blur: '10px', // 10px
			borderradius: '5px', // 5px
			border: '1px solid rgb(185, 185, 185)',
			boxshadow: '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)',
			headercolor: '#5e828a',
			headertxcolor: '#ffffff',
			btncolor: '#5e828a',
			btntxcolor: '#ffffff',
			bgcolor: '#ffffff',
			tx: '#333333',
			showIcon: true, // button checkmark icon
		}
	},

	// TEXTS
	translations: {
		de: {
			consentModal: {
				description: 'Hier können Sie einsehen und anpassen, welche Information wir über Sie sammeln und welche Dienste wir auf dieser Seite verwenden.',
			},
			klaro: {
				description: 'Tool zur Verwaltung und Protokollierung der Datenerfassungszustimmung. Keine externe Verbindung oder Speicherung von Daten. Cookie wird gesetzt, um die Privatsphäre-Einstellungen der Benutzer zu speichern.'
			},
			purposes: {
                analytics: 'Besucher-Statistiken',
				social: 'Soziale Medien',
				video: 'Multimedia',
				advertising: 'Werbung',
				consent: 'Datenschutz Zustimmungen'
            },
			acceptSelected: 'Auswahl akzeptieren',
			acceptAll: 'Alle akzeptieren',
			ok: 'Akzeptieren',
			decline: 'Alle ablehnen',
			consentNotice: {
				learnMore: 'Einstellungen',
				description: 'Diese Seite nutzt Website Tracking-Technologien von Dritten, um ihre Dienste anzubieten, stetig zu verbessern und Inhalte entsprechend der Interessen der Nutzer anzuzeigen. Ich bin damit einverstanden und kann meine Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen oder ändern. Technologien werden für folgende Zwecke verwendet: {purposes}'
			},
			noticeHTML: '<div class="klaro-notice"><p>Diese Einstellungen können Sie jederzeit auf der <a class="nohint" href="' + klaroConfig.privacyPolicy + '" target="_blank">Datenschutz Seite</a> oder im Footer über <a class="nohint" href="#" onclick="javascript:klaro.show();return false;" target="_blank">"Cookie-Einstellungen"</a> bearbeiten.</p></div>'
		},
		en: {
			consentModal: {
				description: 'Here you can see and customize the information that we collect about you.',
			},
			klaro: {
				description: 'Data-Collection Consent Management tool. No external storing of data. Cookie will be set to save privacy user settings.'
			},
			purposes: {
                analytics: 'Analytics',
                security: 'Security',
                livechat: 'Livechat',
                advertising: 'Advertising',
                styling: 'Styling',
                video: 'Multimedia',
				consent: 'Privacy Consent'
			},
			acceptSelected: 'Accept selected',
			consentNotice: {
				learnMore: 'Settings',
				description: 'This site uses third-party website tracking technologies to provide its services, to continually improve and to display content according to the interests of users. I agree to this and can revoke or change my consent at any time in the future. Technologies are used for the following purposes: {purposes}'
			},
			noticeHTML: '<div class="klaro-notice"><p>You can edit these settings at any time on the <a class="nohint" href="' + klaroConfig.privacyPolicy + '" target="_blank">PrivacyPolicy page</a> or in the footer via <a class="nohint" href="#" onclick="javascript:klaro.show();return false;" target="_blank">"Privacy settings"</a>.</p></div>'
		}
	},

	// APPS
	apps: [],
};

var customActivateKlaroConsent = function(name) {
	klaro.getManager().updateConsent(name, true);
	klaro.getManager().saveAndApplyConsents();
	return true;
}

var klaroConsentLogging = {
	init: false,
	send: function(name, value) {
		var loggerurl = (klaroConfig.cmloggerurl != '' ? klaroConfig.cmloggerurl : '');
		var self = this;
		if ((self.init && loggerurl != '') || (!self.init && name == 'klaro') && !localStorage.getItem('consent')) { // && name != 'klaro'
			// console.log('sending', name, value);
			var httpc = new XMLHttpRequest();
			var url = loggerurl;
			httpc.open("POST", url, true); // sending as POST

			httpc.onreadystatechange = function() {
				if (httpc.readyState == 4 && httpc.status == 200) {
				}
			};
			var payload = {
				consent: name,
				value: value,
				platform: window.navigator.platform
			}
			httpc.send(JSON.stringify(payload));
		}

		if (value) {

		}
	}
}

window.addEventListener("load", function(){
	if (typeof(klaro) == 'object') {
		klaroConsentLogging.init = true;
		var klaroContainer = document.getElementById("klaro");

		klaroConfig.lang = (klaro.language() == 'de' ? 'de' : 'en');

		// add fullscreen class
		if (klaroConfig.fullScreen) {
			klaroContainer.classList.add("klaro--fullscreen");
		}

		// custom extra classes
		if (typeof klaroConfig.extraClasses == 'object') {
			for (var i = 0; i < klaroConfig.extraClasses.length; i++) {
				if (klaroConfig.extraClasses[i] != '') {
					klaroContainer.classList.add(klaroConfig.extraClasses[i]);
				}
			}
		}

		// listen for #klaro links to trigger consent manager
		var klaroLinks = document.querySelectorAll('a[href$="#klaro"]');
		for (var i = 0; i < klaroLinks.length; i++) {
			klaroLinks[i].addEventListener('click', function(e) {
				e.preventDefault();
				klaro.show();
				return false;
			});
		};

		// create notice or trigger for user access to settings
		switch (klaro.getManager().config.noticetype) { // change in config
			case 'trigger': // add trigger to page corner when klaro windows gone
				var triggerdiv = document.createElement('div');
				triggerdiv.classList.add("klaro-trigger--wrap");
				triggerdiv.classList.add("klaro-trigger--hide");
				triggerdiv.innerHTML = '<div class="klaro-trigger" onclick="javascript:klaro.show();return false;"></div>';
				document.body.appendChild(triggerdiv);
				var checkKlaro = setInterval(function() {
					if (!document.querySelectorAll('#klaro .cookie-notice').length && !document.querySelectorAll('#klaro .cookie-modal').length) {
						clearInterval(checkKlaro);
						document.querySelectorAll('.klaro-trigger--wrap')[0].classList.remove('klaro-trigger--hide');
					}
				}, 1000);
				break;
			case 'notice': // add notice to inform about settings access when klaro windows gone
				if (!localStorage.getItem('consent')) {
					var noticediv = document.createElement('div');
					noticediv.classList.add("klaro-notice--wrap");
					noticediv.classList.add("klaro-notice--hide");
					noticediv.innerHTML = klaroConfig.translations[klaroConfig.lang].noticeHTML;
					document.body.appendChild(noticediv);
					var checkKlaro = setInterval(function() {
						if (!document.querySelectorAll('#klaro .cookie-notice').length && !document.querySelectorAll('#klaro .cookie-modal').length) {
							clearInterval(checkKlaro);
							document.querySelectorAll('.klaro-notice--wrap')[0].classList.remove('klaro-notice--hide');
							setTimeout(function() {
								document.querySelectorAll('.klaro-notice--wrap')[0].classList.add('klaro-notice--hide');
							}, 4000);
						}
					}, 1000);
				}
				break;
			default:
				console.warn('undefined klaroConfig.noticetype | possible values: ["trigger", "notice"]')
				break;
		}


		// custom klaro iframe blocker
		// iframe attributes => replace src => data-src + add data-name + add data-thumb
		if (klaroConfig.iframe.enable) {
		var fr = document.getElementsByTagName("iframe");
		for (var i = 0; i < fr.length; i++) {
			if (fr[i].hasAttribute('data-name') || fr[i].hasAttribute('data-consent-name')) {
				var frame = fr[i];
				// only execute if exists in klaro and has not been accepted yet
				if ((klaro.getManager().states[frame.getAttribute("data-name")] !== undefined && !klaro.getManager().states[frame.getAttribute("data-name")]) || (klaro.getManager().states[frame.getAttribute("data-consent-name")] !== undefined && !klaro.getManager().states[frame.getAttribute("data-consent-name")])) {
					var frname = frame.getAttribute("data-name") || frame.getAttribute("data-consent-name");
					frame.classList.add('consent--iframe');

					var frapp = klaro.getManager().getApp(frname);
					var frtranslations = klaroConfig.translations[klaro.language()];
					var frtitle = (frapp.title ? frapp.title : frname);
					var frdescription = (frtranslations[frname] ? frtranslations[frname].description : '');
					var frpurposes = '';
					for (var j = 0; j < frapp.purposes.length; j++) {
						frpurposes += frtranslations.purposes[frapp.purposes[j]] + ' ';
					}
					var frWindow = fr[i].contentWindow;
					var frDocument = frWindow.document;
					var body = frDocument.body;
					var cs = klaroConfig.iframe.styles;
					var url = frame.getAttribute("data-src");

					var background = frDocument.createElement("div");
						background.className = 'ki--bg';

					var noticeWrapper = frDocument.createElement("div");
						noticeWrapper.className = 'ki--wrapper';

					var noticeHeader = frDocument.createElement("h3");
						noticeHeader.className = 'ki--header';
						noticeHeader.innerHTML = klaroConfig.iframe.texts[klaroConfig.lang].title + ' ';
						var noticeTitle = frDocument.createElement("strong");
							noticeTitle.innerHTML = frtitle;
							noticeHeader.appendChild(noticeTitle);

					var noticeInfo = frDocument.createElement("p");
						noticeInfo.className = 'ki--info';
						noticeInfo.innerHTML = frdescription + ' ' + klaroConfig.iframe.texts[klaroConfig.lang].desc + ' ';;

					var infoButton = frDocument.createElement("button");
						infoButton.className = 'ki--button ki--button--info';
						infoButton.innerHTML = klaroConfig.iframe.texts[klaroConfig.lang].infobtn;
						infoButton.setAttribute('onClick', 'javascript:parent.klaro.show()');

					var noticeButton = frDocument.createElement("button");
						noticeButton.className = 'ki--button';
						noticeButton.innerHTML = klaroConfig.iframe.texts[klaroConfig.lang].btn + ' ';
						noticeButton.setAttribute('onClick', 'javascript:parent.customActivateKlaroConsent("' + frname + '")');

						if (cs.showIcon) {
							var noticeButtonIcon = frDocument.createElement("span");
							noticeButtonIcon.className = 'ki--button--icon';
							noticeButton.appendChild(noticeButtonIcon);
						}

					noticeWrapper.appendChild(noticeHeader);
					noticeWrapper.appendChild(noticeInfo);
					noticeWrapper.appendChild(noticeButton);
					noticeWrapper.appendChild(infoButton);
					body.appendChild(background);
					body.appendChild(noticeWrapper);

					// add CSS // --> escape linebreaks with \
					var s = document.createElement('style');
					s.setAttribute('type', 'text/css');
					frDocument.getElementsByTagName('head')[0].appendChild(s);
					const sheet = frDocument.styleSheets[0];
					sheet.insertRule('body { \
						font-family: '+cs.font+';\
						font-size:16px;\
						overflow:hidden;\
					}', 0);
					sheet.insertRule('.ki--bg { \
						background: url(' + frame.getAttribute("data-thumb") + ') center center no-repeat;\
						background-size: cover;\
						background-color: #f1f1f1;\
						filter: blur('+cs.blur+');\
						position: absolute;\
						top: 0;\
						bottom: 0;\
						left: 0;\
						right: 0;\
						width: calc(100% + calc('+cs.blur+' * 3));\
						left: calc(calc(-'+cs.blur+' * 3) / 2);\
						height: calc(100% + calc('+cs.blur+' * 3));\
						top: calc(calc(-'+cs.blur+' * 3) / 2);\
					}', 0);
					sheet.insertRule('.ki--wrapper { \
						position: absolute;\
						top: 50%;\
						left: 50%;\
						transform: translate(-50%, -50%);\
						background: '+cs.bgcolor+';\
						border-radius: '+cs.borderradius+';\
						box-shadow: '+cs.boxshadow+';\
						padding: 8px 16px;\
						width: 80%;\
						max-width: 560px;\
						color:'+cs.tx+';\
						overflow: hidden;\
						border: '+cs.border+';\
					}', 0);
					sheet.insertRule('.ki--header { \
						font-size: 20px;\
						margin: 10px 0px;\
						background: '+cs.headercolor+';\
						color: '+cs.headertxcolor+';\
						font-weight: 400;\
						padding: 10px 16px;\
						margin-left: -16px;\
						margin-right: -16px;\
						margin-top: -9px;\
						border-radius: '+cs.borderradius+' '+cs.borderradius+' 0 0;\
					}', 0);
					sheet.insertRule('.ki--info { \
						line-height:1.2rem;\
						font-size:.9rem;\
						opacity:.8;\
						color:'+cs.tx+';\
					}', 0);
						sheet.insertRule('@media only screen and (max-width: 560px) { .ki--info { \
							font-size:0 !important;\
						}}', 0);
					sheet.insertRule('.ki--button { \
						display: block;\
						float: right;\
						border:0;\
						padding: 10px;\
						font-weight:bold;\
						color:'+cs.btntxcolor+';\
						background: '+cs.btncolor+';\
						border: 0;\
						border-radius: '+cs.borderradius+';\
					}', 0);
						sheet.insertRule('.ki--button--info { \
							margin-right:5px;\
						}', 0);
						sheet.insertRule('@media only screen and (min-width: 560px) { .ki--button--info { \
							display: none !important;\
						}}', 0);
					sheet.insertRule('.ki--button--icon { \
						margin-left: 7px;\
						margin-bottom: 3px;\
						position: relative;\
						display: inline-block;\
						width: 12px;\
						height: 6px;\
						border-left: 2px solid white;\
						border-bottom: 2px solid white;\
						transform: rotate(-45deg);\
					}', 0);
				}
			}
		}
		} //endif enable iframe

		var lcWrap = document.getElementsByClassName("load-consent");
		if(lcWrap){
			var lc = $(lcWrap);
			for (var i = 0; i < lc.length; i++) {
				if (lc[i].hasAttribute('data-name') || lc[i].hasAttribute('data-consent-name')) {
					
					var consentframe = lc[i];
					// only execute if exists in klaro and has not been accepted yet
					if ((klaro.getManager().states[consentframe.getAttribute("data-name")] !== undefined && !klaro.getManager().states[consentframe.getAttribute("data-name")]) || (klaro.getManager().states[consentframe.getAttribute("data-consent-name")] !== undefined && !klaro.getManager().states[consentframe.getAttribute("data-consent-name")])) {
						var lcname = consentframe.getAttribute("data-name") || consentframe.getAttribute("data-consent-name");

						consentframe.classList.add('consent--wrapper');

						var lcapp = klaro.getManager().getApp(lcname);
						var lctranslations = klaroConfig.translations[klaro.language()];
						var lctitle = (lcapp.title ? lcapp.title : lcname);
						var lcdescription = (lctranslations[lcname] ? lctranslations[lcname].description : '');
						var lcpurposes = '';
						for (var j = 0; j < lcapp.purposes.length; j++) {
							lcpurposes += lctranslations.purposes[lcapp.purposes[j]] + ' ';
						}
						var lcBodyWrap = lc[i];
						// var lcBody = lc[i];
						// var cs = klaroConfig.iframe.styles;
						var url = consentframe.getAttribute("data-src");

						lcBodyWrap = $(lcBodyWrap);
						var htmlData = '';
						var htmlHeader = '<h3 class="ki--header">'+klaroConfig.iframe.texts[klaroConfig.lang].title+'<strong>'+lctitle+'</strong></h3>';
						var htmlInfo = '<p class="ki--info">'+lcdescription+ ' ' + klaroConfig.iframe.texts[klaroConfig.lang].desc + ' </p>';
						var htmlInfoButton = '<button class="ki--button ki--button--info" onclick="javascript:parent.klaro.show()">'+klaroConfig.iframe.texts[klaroConfig.lang].infobtn+'</button>';
						var htmlNoticeButton = '<button class="ki--button ki--button--activate">' + klaroConfig.iframe.texts[klaroConfig.lang].btn + ' <span class="ki--button--icon"></span></button>';
						//

						htmlData = htmlHeader + htmlInfo + htmlInfoButton + htmlNoticeButton;

						var addInfo = lcBodyWrap.append('<div class="ki--bg"></div><div class="ki--wrapper">'+htmlData+'</div>');
			
						lcBodyWrap.find('.ki--button.ki--button--activate').attr('onClick', 'javascript:parent.customActivateKlaroConsent("' + frname + '")');
		
					}
					
				}
			}
		} 

	}
});

// noES6-deepmerge script : https://davidwalsh.name/javascript-deep-merge
function isMergeableObject(e){return e&&"object"==typeof e&&"[object RegExp]"!==Object.prototype.toString.call(e)&&"[object Date]"!==Object.prototype.toString.call(e)}function emptyTarget(e){return Array.isArray(e)?[]:{}}function cloneIfNecessary(e,r){return r&&!0===r.clone&&isMergeableObject(e)?deepmerge(emptyTarget(e),e,r):e}function defaultArrayMerge(e,r,t){var a=e.slice();return r.forEach(function(r,c){void 0===a[c]?a[c]=cloneIfNecessary(r,t):isMergeableObject(r)?a[c]=deepmerge(e[c],r,t):-1===e.indexOf(r)&&a.push(cloneIfNecessary(r,t))}),a}function mergeObject(e,r,t){var a={};return isMergeableObject(e)&&Object.keys(e).forEach(function(r){a[r]=cloneIfNecessary(e[r],t)}),Object.keys(r).forEach(function(c){isMergeableObject(r[c])&&e[c]?a[c]=deepmerge(e[c],r[c],t):a[c]=cloneIfNecessary(r[c],t)}),a}function deepmerge(e,r,t){var a=Array.isArray(r),c=(t||{arrayMerge:defaultArrayMerge}).arrayMerge||defaultArrayMerge;return a?Array.isArray(e)?c(e,r,t):cloneIfNecessary(r,t):mergeObject(e,r,t)}deepmerge.all=function(e,r){if(!Array.isArray(e)||e.length<2)throw new Error("first argument should be an array with at least two elements");return e.reduce(function(e,t){return deepmerge(e,t,r)})};

// merge baseConfig with "Site-"klaroConfig
klaroConfig = deepmerge.all([klaroBaseConfig, klaroConfig]);


const klaroApp = {
	name: 'klaro',
	title: 'Klaro Consent Management',
	callback: function(consent, app) {
		klaroConsentLogging.send(app.name, consent);
	},
	purposes: ['consent'],
	required: true
};
klaroConfig.apps.push(klaroApp);
